var path = 'entity/entity-subtype-select.tpl.html';
var html = " <md-input-container> <label ng-if=showLabel>{{ entitySubtypeTitle | translate }}</label> <md-select name=subType ng-model=entitySubtype class=tb-entity-subtype-select aria-label=\"{{ entitySubtypeTitle | translate }}\"> <md-option ng-repeat=\"subType in entitySubtypes\" ng-value=subType> {{ subTypeName(subType) }} </md-option> </md-select> <div ng-messages=theForm.subType.$error> <div ng-message=required translate>{{ entitySubtypeRequiredText }}</div> </div> </md-input-container> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/entity/entity-subtype-select.tpl.html
// module id = 1470
// module chunks = 1